import { Box, SxProps, Theme, useTheme } from '@mui/material';

import { FC } from 'react';

import Link from 'next/link';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface socialIconProps {
  logo: string;
  path: string;
  /**
   * Accessible name for the link. These are icon-only anchors, so without it
   * they have no name at all and every one of them is announced identically.
   * Network names are proper nouns, so they are not run through react-intl.
   */
  name: string;
}

export const SocialIcon: FC<socialIconProps> = ({ logo, path, name }) => {
  const theme = useTheme();
  const sxSocialIcon: Partial<SxProps<Theme>> = {
    backgroundColor: 'white',
    borderRadius: '100%',
    width: pxToRem(50),
    height: pxToRem(50),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transitionDuration: '300ms',
    ':hover': {
      backgroundColor: theme.palette.grey[10],
    },
    ':active': {
      backgroundColor: theme.palette.grey[20],
    },
  };
  return (
    <Link href={{ pathname: path }} legacyBehavior
        passHref>
      <Box sx={sxSocialIcon} component='a' target={'_blank'} aria-label={name}>
        {/*
          Decorative: the anchor carries the accessible name, so an alt here
          would only make screen readers announce the same link twice.
        */}
        <ImageBoxFuture
          img={logo}
          title=''
          objectFit='contain'
          sx={{
            height: pxToRem(30),
            width: pxToRem(30),
          }}
        />
      </Box>
    </Link>
  );
};

export default SocialIcon;
